import { render, staticRenderFns } from "./Notches.vue?vue&type=template&id=677137fc&scoped=true&"
import script from "./Notches.vue?vue&type=script&lang=js&"
export * from "./Notches.vue?vue&type=script&lang=js&"
import style0 from "./Notches.vue?vue&type=style&index=0&id=677137fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677137fc",
  null
  
)

export default component.exports